<script setup>
import {onMounted, ref} from "vue";
import homeApi from "@/api/homeApi";

onMounted(()=>{
  getList()
})

const activeNames = ref([])
const linkedList = ref([])
const getList = () => {
  homeApi.getAllLinkedList({type:"1"}).then(res=>{
    linkedList.value = res
    activeNames.value = res.map(e=>e.id)
  })
}

</script>

<template>
  <div class="linked-all">
    <div class="linked-panel">
      <h2 style="text-align: center">学习网站</h2>
      <el-collapse v-model="activeNames">
        <el-collapse-item v-for="(item,index) in linkedList" :name="item.id">
          <template #title>
            <div class="el-descriptions__title">{{item.name}}</div>
          </template>
          <el-space wrap>
            <el-link  v-for="(linked,lIndex) in item.linkedList" style="margin: 6px" type="primary" :href="linked.link" target="_blank">{{linked.name}}</el-link>
          </el-space>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<style scoped lang="less">
.linked-all{
  width: 1280px;
  margin: 24px auto;
  background: #f3f4f7;
}

.linked-panel{
  border-radius: 12px;
  width: 100%;
  min-height: 500px;
  background: #ffffff;
  padding: 2px 24px 40px;
}
</style>
<style lang="less">
.el-descriptions__body{
  .el-card__body{
    padding: 12px !important;
  }
}
</style>